import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const RetakeStatusGuard = ({ children }) => {
    const { audit_id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkStatus = async () => {
            try {
                const response = await axios.post("/create_audit/get_retake_status", { audit: audit_id });
                if (response.data.retake_status === "processing" || response.data.retake_status === "processed") {
                    // navigate("/successful");
                    navigate(`/successful/${audit_id}`);

                } else {
                    setLoading(false); // show wrapped component
                }
            } catch (error) {
                console.error("Error checking retake status:", error);
                setLoading(false); // fail-safe: still allow route
            }
        };

        checkStatus();
    }, [audit_id, navigate]);

    if (loading) return null; // or show a loader

    return children;
};
export default RetakeStatusGuard;
